export const SUCCESS_RESPONSE = "Success"
export const FAILED_RESPONSE = "Failed"


export const ApiResponseSuccess = 1
export const APiResponseError = 0

export const ApiResponseStatusOk = 200
export const ApiResponseStatusNotFound = 400
export const ApiResponseStatusUnauthorized = 401
export const ApiResponseStatusInternalServerError = 500

export const AxiosNetworkError = "ERR_NETWORK"

export const EmptyString = ""
export const Undefined = "undefined"
export const DefaultErrorMessage = "An error has occured. Please contact IT Support"

export const FormTypeAdd = "Add"
export const FormTypeEdit = "Edit"
export const FormTypeView = "View"

export const PageTypeGetPaged = "GetPaged"
export const PageTypeCount = "Count"

export const PageSize = 25

export const PaginationFirst = "First"
export const PaginationBack = "Back"
export const PaginationNext = "Next"
export const PaginationLast = "Last"

export const GuidDefault = "00000000-0000-0000-0000-000000000000"
export const DateNullDefault = "0001-01-01T00:00:00"

export const Active = "Active"
export const Deleted = "Deleted"

export const StatusCodeDelete = "2"

export const DepositReceived = "Received"
export const NoDeposit = "No Deposit"

export const DropdownStatusList = [
    {label: "All", value: "0"},
    {label: "Active", value: "1"},
    {label: "Delete", value: "2"}
]

export const DropdownPaymentType = [
    {label: "All", value: "0"},
    {label: "Termin 1", value: "1"},
    {label: "Termin 2", value: "2"},
    {label: "Termin 3", value: "3"},
    {label: "Termin 4", value: "4"},
    {label: "Termin 5", value: "5"},
]

export const MenuHomeId = ""
export const MenuCompanyId = ""
export const MenuBankId = ""
export const MenuProjectId = "4"
export const MenuPaymentId = "5"
export const MenuPaymentSubConId = "6"
export const MenuIncProjectId = "7"
export const MenuSubConId = "8"
export const MenuProductionBankId = "9"
